module.exports = __webpack_public_path__ + "img/hero-bg.96690a1e.jpg";